import { render, staticRenderFns } from "./q-checkbox.vue?vue&type=template&id=4ba69c1b&scoped=true&"
import script from "./q-checkbox.vue?vue&type=script&lang=js&"
export * from "./q-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./q-checkbox.vue?vue&type=style&index=0&id=4ba69c1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba69c1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yangxinyuan/vhall/vhall_questionnaire_service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba69c1b')) {
      api.createRecord('4ba69c1b', component.options)
    } else {
      api.reload('4ba69c1b', component.options)
    }
    module.hot.accept("./q-checkbox.vue?vue&type=template&id=4ba69c1b&scoped=true&", function () {
      api.rerender('4ba69c1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questionnaire/q-checkbox.vue"
export default component.exports